module.exports = __webpack_public_path__ + "img/child@2x.7fa8ce8a.jpg";